import React, { Component } from "react";

import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import MobileSubHeader from "../../../components/PageHeader/MobileSubHeader";
import StringInput from "../../../components/Input/StringInput/StringInput";
import NumberInput from "../../../components/Input/NumberInput/NumberInput";

export class EditEmailAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            varificationCode: "",
        };
    }

    updateEmail = (e) => {
        const { t } = this.props;
        e.preventDefault();

        Swal.fire({
            iconHtml: '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">',
            icon: "success",
            title: t('global.success'),
            text: t('validation.sucess-update-email'),
            showConfirmButton: true,
            customClass: {
                container: "swal-mobile-container sucess",
                icon: "swal-success-icon",
                confirmButton: "w-75",
            },
        });
    };

    render() {
        const { t } = this.props;

        return (
            <section className="verification-m-section pf-m-dashboard on-top d-block pe-auto">
                <MobileSubHeader className="bg-white" closeModalHandler={this.props.backToPersonalDetails} header={t("profile.verification-email-address")} style={{ justifyContent: "unset" }} />

                <form
                    className="forms-col needs-validation my-3"
                    onSubmit={this.props.verifyEmail}
                    name="email_verification_from"
                    id="email_verification_from"
                    method="post"
                    noValidate
                >
        
                    <div className="pd-form-m-col">
                        <div className="input-group-col">
                            <label className="col-form-label p-0 m-0">{t("profile.email-address")}</label>
                            <div className="input-group left has-validation pb-3">
                                <StringInput
                                    // className={`${this.props.errorMsg.mobile_no && "was-validated is-invalid"}`}
                                    className="form-control"
                                    type="email"
                                    placeholder={t("profile.email-address")}
                                    name="emailAddress"
                                    defaultValue=""
                                    value={this.props.email}
                                    onChange={(e) => this.props.enterEmail(e)}
                                    // minLength={contact_no_min_limits}
                                    // maxLength={contact_no_max_limits}
                                    // minLengthMessage={t("validation.minLength", { 0: contact_no_min_limits })}
                                    // maxLengthMessage={t("validation.maxLength", { 0: contact_no_max_limits })}
                                    required
                                    requiredMessage={t("validation.required")}
                                    errorMsg={this.props.errorMsg.email || ""}
                                    // formError={this.props.formError}
                                    autoComplete="off"
                                />
                            </div>

                            <div className="pt-3 border-top">
                                <label className="col-form-label p-0 m-0">{t("profile.verification-code")}</label>
                                <div className="verificate-m-input">
                                    <NumberInput
                                        // className={`form-control ${this.props.sms_otp_code.length > 5 ? "is-valid" : "was-validated"}`}
                                        className={`form-control`}
                                        type="number"
                                        onChange={(e) => this.props.enterEmailVarificationCode(e)}
                                        placeholder={t("profile.enter-verification-code")}
                                        errorMsg={this.props.errorMsg.otp_code || ""}
                                        // formError={this.props.formError}
                                        required
                                        requiredMessage={t("validation.required")}
                                        value={this.props.emailVarificationCode}
                                    />

                                    <button className="btn btn-blue" type="button" onClick={this.props.generateEmailOTP}>
                                        {t("forgot-password.request")}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button
                            className="btn btn-gradient-blue mx-3"
                            type="submit"
                            // disabled
                            // disabled={!this.props.currentMobileNo || (this.props.sms_otp_code.length < 6 && "active")}
                        >
                            {t("global.submit")}
                        </button>
                        {/* <p className="notice-desc px-3">
                            For your safety, the information cannot be modified after confirmation, please contact
                            <Link to={{ pathname: "/" }}> customer service </Link> if you need help.
                        </p> */}
                    </div>
                </form>
            </section>
        );
    }
}

export default (withNamespaces(EditEmailAddress));
